import React, { useState, useEffect, FormEvent } from "react";
import * as Styled from "./styles";
import { useParams, useHistory } from "react-router-dom";
import {
  HeaderBottom,
  StatusTool,
  GOLayout,
  GOLoading,
  GOLayoutBox,
  GOLabel,
  SmallTitle,
  ProductPanel,
  SalesTable,
  GODropbox,
  GOInput,
  Footer,
  GOButton,
  GOSwitch
} from "../../../components";
import { useTranslation } from "react-i18next";
import {
  NetProductDetail,
  NetProductEmployeeList,
  NetSalesRegister
} from "../../../actions";
import dayjs from "dayjs";

import { toast } from "react-toastify";

interface ParamsType {
  id: string;
  productID: string;
}

const Sales = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [productAllData, setProductAllData] = useState<any>({});
  const [productData, setProductData] = useState<any>({});
  const [employeeData, setEmployeeData] = useState<any>([]);
  const [salesData, setSalesData] = useState<any>({
    price: 0,
    card: 0,
    cash: 0,
    transfer: 0,
    discount: 0,
    totalPrice: 0,
    unpaidPrice: 0
  });
  const [paymentData, setPaymentData] = useState<any>({
    name: "",
    managerName: "",
    paymentDate: "",
    startDate: "",
    memo: "",
    employeeID: undefined,
    ticket: {}
  });

  const [validationTotalCount, setValidationTotalCount] = useState<boolean>(
    true
  );

  const params = useParams<ParamsType>();
  const USER_NAME = window.sessionStorage.getItem(`SLID${params.id}`);
  const { t } = useTranslation();

  const history = useHistory();

  const employeeListFilter = employeeData.filter((e: any) => e.type === 2);

  useEffect(() => {
    const today = dayjs().format("YYYY-MM-DD");

    NetProductDetail(params.productID).then((res: any) => {
      setProductAllData(res.data.Data.ProductCategory);
      setProductData({
        ...res.data.Data.ProductCategory.Products[0],
        usedCount: 0,
        remainingCount: res.data.Data.ProductCategory.Products[0].totalCount,
        startDate: dayjs().format("YYYY-MM-DD"),
        endDate: dayjs()
          .add(res.data.Data.ProductCategory.Products[0].period - 1, "day")
          .format("YYYY-MM-DD")
      });
      setPaymentData({
        name: res.data.Data.ProductCategory.Products[0]?.name,
        managerName: res.data.Data.ProductCategory.Products[0].Employee?.name,
        paymentDate: today,
        startDate: today,
        memo: "",
        employeeID: res.data.Data.ProductCategory.Products[0].Employee?.id,
        ticket: {}
      });
      setLoading(false);
    });
  }, [params]);

  useEffect(() => {
    NetProductEmployeeList().then((res: any) => {
      setEmployeeData(res.data.Data.Employees);
    });
  }, []);

  const handleDate = (startDate: any, period: any, pData?: any) => {
    const endDate = dayjs(startDate)
      .add(period - 1, "day")
      .format("YYYY-MM-DD");
    if (pData) {
      setProductData({ ...pData, period, startDate, endDate });
    } else {
      setProductData({ ...productData, period, startDate, endDate });
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (productData.startDate === 0) {
      const today = dayjs().format("YYYY-MM-DD");
      const endDate = dayjs()
        .add(productData.period - 1, "day")
        .format("YYYY-MM-DD");
      setProductData({
        ...productData,
        startDate: today,
        endDate
      });
    } else if (name === "startDate") {
      const startDate = value;
      handleDate(startDate, productData.period);
      setPaymentData({
        ...paymentData,
        startDate: dayjs(value).format("YYYY-MM-DD")
      });
    } else if (name === "employeeID") {
      setPaymentData({ ...paymentData, [name]: parseInt(value) });
    } else setPaymentData({ ...paymentData, [name]: value });
  };

  const ticketHandleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "employeeID") {
      setProductData({ ...productData, [name]: parseInt(value) });
    } else if (name === "period") {
      setProductData({ ...productData, [name]: value });
    } else if (name === "totalCount") {
      if (
        (productData.type === 2 || productData.type === 0) &&
        productData.isUnlimited === false &&
        value < 1
      ) {
        setValidationTotalCount(false);
      } else {
        setValidationTotalCount(true);
      }
      setProductData({ ...productData, [name]: value, remainingCount: value });
    } else setProductData({ ...productData, [name]: value });
  };

  const handleSubmit = (e: FormEvent<EventTarget>) => {
    e.preventDefault();

    let hour = new Date().getHours();
    let minute = new Date().getMinutes();
    let second = new Date().getSeconds();

    const temp = {
      userID: params.id,
      Payment: {
        ...paymentData,
        paymentDate: dayjs(
          `${paymentData.paymentDate}T${hour}:${minute}:${second}`
        ).format("YYYY-MM-DDTHH:mm:ss"),
        managerName: employeeData.filter(
          (ed: any) => ed.id * 1 === paymentData.employeeID * 1
        )[0]?.name,
        ...salesData,
        ticket: productData
      }
    };

    let isViolatedTicketCondition = false;
    try {
      isViolatedTicketCondition =
        (productData.type === 2 || productData.type === 0) &&
        productData.isUnlimited === false &&
        productData.totalCount < 1;
    } catch (e) {
      console.log(e);
      isViolatedTicketCondition = false;
    }

    console.log(productData);
    console.log(isViolatedTicketCondition);

    if (isViolatedTicketCondition) {
      setValidationTotalCount(false);
      toast(t("user.errorMsgCheckCount"));
      alert(t("user.errorMsgCheckCount"));
    } else if (temp.Payment.unpaidPrice < 0) {
      alert(t("user.errorMsgNoMatch"));
    } else if (temp.Payment.unpaidPrice > 0) {
      if (window.confirm(t("user.errorMsgUnpaid"))) {
        NetSalesRegister(temp).then(() => {
          alert("saleRegisterComplete");
          history.push(`/admin/user/${params.id}`);
        });
      }
    } else if (window.confirm(t("user.registerSale"))) {
      NetSalesRegister(temp).then(() => {
        // alert("판매가 등록되었습니다.");
        alert(t("user.saleRegisterComplete"));
        history.push(`/admin/user/${params.id}`);
      });
    }
  };

  const typeString = () => {
    const pType = productData?.type;

    if (pType === 0) return t("ticket.lesson");
    else if (pType === 1) return t("ticket.groupLesson");
    else if (pType === 2) return t("ticket.plate");
    else if (pType === 3) return t("ticket.room");
    else if (pType === 4) return t("ticket.locker");
    else if (pType === 5) return t("ticket.etc");
    else if (pType === 6) return t("ticket.special");
  };

  return (
    <>
      <HeaderBottom
        status={
          <>
            <StatusTool link="/admin" type="prev" body={t("main-menu.home")} />
            <StatusTool type="arrow" />
            <StatusTool
              link="/admin/user/grid"
              type="prev"
              body={t("user.list")}
            />
            <StatusTool type="arrow" />
            <StatusTool
              link={`/admin/user/${params.id}`}
              type="prev"
              body={USER_NAME ? USER_NAME : params.id}
            />
            <StatusTool type="arrow" />
            <StatusTool
              link={`/admin/user/${params.id}/sales`}
              type="prev"
              body={t("user.product")}
            />
            <StatusTool type="arrow" />
            <StatusTool type="now" body={t("sales.register")} />
          </>
        }
        rightmenu={<></>}
      />
      <Styled.PageForm onSubmit={handleSubmit}>
        <GOLayout
          body={
            loading ? (
              <GOLoading />
            ) : (
              <Styled.BoxWrapper>
                <GOLayoutBox
                  body={
                    <>
                      <SmallTitle body={t("sales.productInfo")} />
                      <ProductPanel
                        data={productData}
                        link={`/admin/product/${productData.id}`}
                        category={productAllData}
                        view
                      />
                      <br />
                      <br />
                      <SmallTitle body={t("sales.userInfo")} />
                      <GOLabel label={t("user.name")} body={USER_NAME} />
                      <GOLabel label={t("user.number")} body={params.id} />
                    </>
                  }
                />
                <GOLayoutBox
                  body={
                    <>
                      <SmallTitle body={t("sales.payment")} />
                      <SalesTable
                        productData={productData}
                        salesData={salesData}
                        setSalesData={setSalesData}
                      />
                      <br />
                      <SmallTitle body={t("sales.detail")} />
                      <GOInput
                        label={t("sales.paymentInCharge")}
                        value={productData.Employee?.name}
                        disabled={true}
                      />
                      <GOInput
                        label={t("sales.paymentDay")}
                        name="paymentDate"
                        type="date"
                        value={paymentData.paymentDate}
                        onChange={handleChange}
                        required
                      />
                      <GOInput
                        label={t("sales.startValidity")}
                        name="startDate"
                        type="date"
                        value={paymentData.startDate}
                        onChange={handleChange}
                        required
                      />
                      <GOInput
                        label={t("sales.paymentMemo")}
                        name="memo"
                        value={paymentData.memo}
                        onChange={handleChange}
                        textarea
                      />
                    </>
                  }
                />
                <GOLayoutBox
                  body={
                    <>
                      <SmallTitle body={t("sales.ticketDetail")} />
                      <Styled.Panel>
                        <SmallTitle
                          body={`${typeString()} / ${productData.name}`}
                        />
                        <GOInput
                          label={t("sales.period")}
                          name="period"
                          unit={t("sales.unitDay")}
                          type="number"
                          min="0"
                          max="999"
                          value={productData.period}
                          onChange={(e: any) => {
                            ticketHandleChange(e);
                            handleDate(
                              productData.startDate,
                              e.target.value,
                              productData
                            );
                          }}
                          required
                        />
                        {productData.type === 4 ? (
                          <div style={{ marginBottom: "80px" }} />
                        ) : (
                          <>
                            <GOInput
                              style={
                                validationTotalCount
                                  ? {}
                                  : {
                                      border: "2px solid red",
                                      transition: "0.25s"
                                    }
                              }
                              label={t("sales.totalCount")}
                              name="totalCount"
                              unit={t("sales.unitCount")}
                              type="number"
                              min="0"
                              max="999"
                              value={productData.totalCount}
                              onChange={ticketHandleChange}
                              disabled={productData.isUnlimited}
                            />
                            <Styled.SwitchBox>
                              <GOSwitch
                                label={t("sales.isUnlimited")}
                                status={productData.isUnlimited}
                                onClick={() => {
                                  if (
                                    (productData.type === 2 ||
                                      productData.type === 0) &&
                                    productData.isUnlimited &&
                                    productData.totalCount < 1
                                  ) {
                                    setValidationTotalCount(false);
                                  } else {
                                    setValidationTotalCount(true);
                                  }
                                  setProductData({
                                    ...productData,
                                    isUnlimited: !productData.isUnlimited
                                  });
                                }}
                              />
                              <GOSwitch
                                label={t("product.onlyOnceToday")}
                                status={productData.onlyOnceToday}
                                onClick={() => {
                                  setProductData({
                                    ...productData,
                                    onlyOnceToday: !productData.onlyOnceToday
                                  });
                                }}
                              />
                            </Styled.SwitchBox>
                          </>
                        )}
                        {(productData.type === 0 || productData.type === 1) && (
                          <>
                            <GODropbox
                              name="employeeID"
                              label={t("product.employee")}
                              data={[
                                ...employeeListFilter?.map((el: any) => {
                                  return { body: el.name, value: el.id };
                                })
                              ]}
                              onChange={ticketHandleChange}
                              value={productData.employeeID}
                              required
                            />
                          </>
                        )}
                      </Styled.Panel>
                    </>
                  }
                />
              </Styled.BoxWrapper>
            )
          }
        />
        <Footer
          body={
            <>
              <GOButton
                buttontype="green"
                body={t("sales.register")}
                type="submit"
              />
            </>
          }
        />
      </Styled.PageForm>
    </>
  );
};

export default Sales;
